<template>
  <div>
    <Card>
      <TablePaginate
        :columns="columns"
        :data="waters"
        :loading="loading"
        :meta="meta"
        :changePage="changePage"
      ></TablePaginate>
    </Card>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import TablePaginate from '@/components/TablePaginate'

export default {
  components: {
    TablePaginate
  },
  data () {
    return {
      columns: [
        {
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: i18n.t('pages_balance_transaction_index_177'),
          key: 'created_at_str',
          width: 200,
          align: 'center'
        },
        {
          title: i18n.t('pages_breakages_index_237'),
          key: 'user_mobile',
          width: 150,
          align: 'center'
        },
        {
          title: i18n.t('pages_balance_transaction_index_175'),
          width: 200,
          align: 'center',
          key: 'price'
        },
        {
          title: i18n.t('pages_bills_index_197'),
          key: 'fresh_order_code'
        }
      ]
    }
  },
  created () {
    this.index()
  },
  computed: {
    ...mapGetters('water', ['waters', 'meta', 'loading'])
  },
  methods: {
    ...mapActions('water', ['index']),
    ...mapMutations('water', ['changeQuery']),
    changePage (page) {
      this.changeQuery({ page })
      this.index()
    }
  }
}
</script>
